export default "<p>notify-transaction works!</p>\r\n";